import Swiper, {Pagination} from 'swiper';

const sliderInit = () => {
	const eventsSlider = document.querySelector('.events__items');
	const commissionSlider = document.querySelector('.commission__items');
	const actorsSlider = document.querySelector('.actors__list');
	const practicesSlider = document.querySelector('.practices__list');

	const commissionSwiper = new Swiper(commissionSlider, {
		speed: 500,
		spaceBetween: 0,
		slidesPerView: 'auto',
		modules: [Pagination],
		pagination: {
			el: '.commission__pagination',
			clickable: true,
		},
	});

	const eventsSwiper = new Swiper(eventsSlider, {
		speed: 500,
		spaceBetween: 0,
		slidesPerView: 'auto',
		modules: [Pagination],
		pagination: {
			el: '.events__pagination',
			clickable: true,
		},
	});

	const actorsSwiper = new Swiper(actorsSlider, {
		speed: 500,
		spaceBetween: 0,
		slidesPerView: 'auto',
		modules: [Pagination],
	});

	const practicesSwiper = new Swiper(practicesSlider, {
		speed: 500,
		spaceBetween: 0,
		slidesPerView: 'auto',
		modules: [Pagination],
		pagination: {
			el: '.practices__pagination',
			clickable: true,
		},
	});
};

export default sliderInit;
